import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "meeting-type-container meeting-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title-container" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Opt Meeting Type")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "message-container" }, "Opt has made it easy to value your time and ensure that others know you value their time as well.", -1 /* HOISTED */)
const _hoisted_5 = { class: "type-button-container" }
const _hoisted_6 = { class: "buttons" }
const _hoisted_7 = { class: "sub2" }
const _hoisted_8 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "outline black-outline",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.setType('collector')))
          }, "Get Paid to Meet"),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goTo('/links')))
            }, "Send Existing Link")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        class: "borderless",
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.emit('previous')))
      }, "Back")
    ])
  ]))
}